import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as App from "@discovery/maestro";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as User from "@discovery/sonic-api-ng/lib/api/users/me";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Profile from "@discovery/sonic-api-ng/lib/api/users/profiles";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import { _UserProfiles } from "../../../components/src/component-creators/hamburger/optics";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
import * as RTE from "fp-ts/ReaderTaskEither";
import { pipe } from "fp-ts/function";
let userDetails;
const _User = Fold.compose(Optics._UserResponse2User, Res._Response(), Fold.liftM((id, attributes) => ({ id, attributes }), Lens.prop("id"), Lens.prop("attributes")));
const setUserIO = (userRes) => {
    const userM = Fold.preview(_User, userRes);
    updateGlobalState(Lens.prop("userM"))((_oldUserM) => userM);
    userDetails = {
        idM: M.map((user) => user.id, userM),
        anonymousM: M.map((user) => user.attributes.anonymous, userM),
        packagesM: M.chain((user) => user.attributes.packages, userM),
        firstNameM: M.chain((user) => user.attributes.firstName, userM),
        lastNameM: M.chain((user) => user.attributes.lastName, userM),
        location: M.map((user) => user.attributes.currentLocationTerritory, userM),
        realm: M.map((user) => user.attributes.realm, userM),
        userPhoneNumberM: M.chain((user) => user.attributes.validatedPhoneNumber, userM),
        userEmailIdM: M.chain((user) => user.attributes.username, userM),
    };
};
//Me api call
export const userReq = pipe(User.Endpoints.getMe(), RTE.chain((user) => RTE.fromIO(() => setUserIO(user))));
// check if the current profile is in all access mode or default mode
// get the reference key from local storage
// key is set in local storage when the profile is switched from default to all access mode
// check the profile, if in all access mode, patch the me api during app startup, else invoke only me api
// handled in template-engine
let isAllAccess;
try {
    isAllAccess = localStorage.getItem("isAllAccess");
}
catch (e) {
    isAllAccess = null;
}
export const isProfileParentalMode = isAllAccess;
export const patchUserReq = App.chainMerge((userMe) => {
    const userM = Fold.preview(_User, userMe);
    const userIdM = M.map(({ id }) => id, userM);
    const userId = M.fromMaybe(userIdM, "");
    let isAllAcess;
    try {
        isAllAcess = sessionStorage.getItem("pA");
    }
    catch (e) {
        isAllAcess = null;
    }
    // clear the reference key stored for parental mode
    isAllAcess === null && localStorage.removeItem("isAllAccess");
    // when in all access mode, do not patch the me api
    // check for session storage reference
    if (isAllAcess === null) {
        // patch the me api to default only if:
        // 1. user terminates the site being in all access modev
        // 2. do not patch for the same session
        return pipe(Profile.Endpoints.getProfiles(), RTE.map((getProfiles) => {
            const userProfilesM = Fold.preview(_UserProfiles, getProfiles);
            const userProfiles = M.fromMaybe(userProfilesM, []);
            const defaultProfile = userProfiles.filter((item) => M.fromMaybe(item.attributes.ageRestricted, false) ===
                true);
            const defaultProfileId = defaultProfile[0].id; //since there will be only one default profile
            return defaultProfileId;
        }), RTE.chainW((selectedProfileId) => User.Endpoints.patchMe(userId, { selectedProfileId })), RTE.chainW(() => User.Endpoints.getMe()), RTE.chain((user) => RTE.fromIO(() => setUserIO(user))));
    }
    return pipe(User.Endpoints.getMe(), RTE.chain((user) => RTE.fromIO(() => setUserIO(user))));
}, User.Endpoints.getMe());
export { userDetails };
